<template>
    <v-container fluid class="create-supplier-page pa-6">

        <!-- Page Header -->
        <div class="create-header mb-6">
            <div>
                <h2 class="create-title">Create New Supplier</h2>
                <span class="create-subtitle grey--text text--darken-1">Add a new supplier to your directory</span>
            </div>
            <v-btn color="primary" rounded elevation="0" class="create-btn" :loading="creating"
                @click="createSupplier()">
                <v-icon left small>mdi-plus</v-icon>
                Create Supplier
            </v-btn>
        </div>

        <!-- Tabs -->
        <v-tabs v-model="tab" background-color="transparent" color="primary" class="create-tabs mb-5">
            <v-tab v-for="section in sections" :key="section.key" class="tab-item">
                <v-icon left small>{{ section.icon }}</v-icon>
                {{ section.label }}
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="tabs-items">

            <!-- ── 1. Basic Info ── -->
            <v-tab-item>
                <v-row>
                    <!-- Left column -->
                    <v-col cols="12" md="8">
                        <v-card class="section-card mb-4" elevation="0">
                            <div class="section-header">
                                <v-icon small class="mr-2" color="#525A68">mdi-information-outline</v-icon>
                                General
                            </div>
                            <v-card-text class="pt-4">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.supplier_name" label="Supplier Name *"
                                            outlined dense hide-details="auto" prepend-inner-icon="mdi-store-outline"
                                            required :error="errors.supplier_name" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="service_type_ids" :items="get_supplier_type" multiple
                                            item-text="name" item-value="id" label="Supplier Types *" outlined
                                            dense hide-details="auto" prepend-inner-icon="mdi-view-list-outline" chips
                                            small-chips deletable-chips required :error="errors.service_type_ids" />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <v-card class="section-card mb-4" elevation="0">
                            <div class="section-header">
                                <v-icon small class="mr-2" color="#525A68">mdi-account-outline</v-icon>
                                Contact Details
                            </div>
                            <v-card-text class="pt-4">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.email" label="Booking Email *" outlined
                                            dense hide-details="auto" prepend-inner-icon="mdi-at" required
                                            :error="errors.email" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.contact_name" label="Contact Name" outlined
                                            dense hide-details="auto" prepend-inner-icon="mdi-account-outline" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.phone" label="Phone" outlined dense
                                            hide-details="auto" prepend-inner-icon="mdi-phone-outline" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.mobile" label="Mobile" outlined dense
                                            hide-details="auto" prepend-inner-icon="mdi-cellphone" />
                                    </v-col>
                                    <!-- <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="new_supplier.free_phone"
                      label="Freephone"
                      outlined dense hide-details="auto"
                      prepend-inner-icon="mdi-phone-outline"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="new_supplier.others"
                      label="Other Number"
                      outlined dense hide-details="auto"
                      prepend-inner-icon="mdi-phone-plus-outline"
                    />
                  </v-col> -->
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.website" label="Website" outlined dense
                                            hide-details="auto" prepend-inner-icon="mdi-web" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.contact_by" label="Preferred Contact Method"
                                            outlined dense hide-details="auto" prepend-inner-icon="mdi-message-outline"
                                            placeholder="e.g. Email, Phone" />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <v-card class="section-card mb-4" elevation="0">
                            <div class="section-header">
                                <v-icon small class="mr-2" color="#525A68">mdi-map-marker-outline</v-icon>
                                Location
                            </div>
                            <v-card-text class="pt-4">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="supplier_locations" :items="getLocation" multiple
                                            item-text="name" item-value="id" label="Locations *" outlined dense
                                            hide-details="auto" prepend-inner-icon="mdi-map-marker-multiple-outline"
                                            chips small-chips deletable-chips required
                                            :error="errors.supplier_locations" />
                                    </v-col>
                                    <!-- <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="new_supplier.location_name"
                      label="Location Name / Area"
                      outlined dense hide-details="auto"
                      prepend-inner-icon="mdi-map-marker-outline"
                    />
                  </v-col> -->
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.address" label="Full Address" outlined dense
                                            hide-details="auto" prepend-inner-icon="mdi-home-outline" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.time_to_center" label="Time to City Center"
                                            outlined dense hide-details="auto" prepend-inner-icon="mdi-clock-outline"
                                            placeholder="e.g. 10 mins" />
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="new_supplier.time_to_arrive" label="Time to Arrive Early"
                                            outlined dense hide-details="auto"
                                            prepend-inner-icon="mdi-clock-check-outline"
                                            placeholder="e.g. 15 mins before" />
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea v-model="new_supplier.directions" label="Directions" outlined dense
                                            hide-details="auto" rows="3" />
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <!-- Right column: Image upload -->
                    <v-col cols="12" md="4">
                        <v-card class="section-card mb-4" elevation="0">
                            <div class="section-header">
                                <v-icon small class="mr-2" color="#525A68">mdi-image-outline</v-icon>
                                Supplier Image
                            </div>
                            <v-card-text class="pt-4 text-center">
                                <div class="image-preview mb-4">
                                    <img v-if="imagePreview" :src="imagePreview" class="supplier-preview-img" />
                                    <div v-else class="image-placeholder">
                                        <v-icon size="56" color="#C8C8C8">mdi-image-plus-outline</v-icon>
                                        <div class="grey--text text--lighten-1 mt-2 caption">Upload supplier image</div>
                                    </div>
                                </div>
                                <v-file-input v-model="supplier_image_file" label="Upload Image" outlined dense
                                    hide-details="auto" prepend-inner-icon="mdi-upload" accept="image/*"
                                    @change="previewImage" />
                            </v-card-text>
                        </v-card>

                        <v-card class="section-card" elevation="0">
                            <div class="section-header">
                                <v-icon small class="mr-2" color="#525A68">mdi-text-long</v-icon>
                                Description
                            </div>
                            <v-card-text class="pt-4">
                                <label class="field-label">Short Description</label>
                                <v-textarea v-model="new_supplier.short_description" label="Short Description" outlined
                                    dense hide-details="auto" rows="1" />
                            </v-card-text>
                            <v-card-text class="pt-4">
                                <label class="field-label">Full Description</label>
                                <wysiwyg v-model="new_supplier.description" />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- ── 2. Policies ── -->
            <v-tab-item>
                <v-card class="section-card mb-4" elevation="0">
                    <div class="section-header">
                        <v-icon small class="mr-2" color="#525A68">mdi-file-document-outline</v-icon>
                        Rules & Policies
                    </div>
                    <v-card-text class="pt-4">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="new_supplier.currency" label="Currency" outlined dense
                                    hide-details="auto" prepend-inner-icon="mdi-currency-usd" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="new_supplier.pay_type" label="Payment Type" outlined dense
                                    hide-details="auto" prepend-inner-icon="mdi-credit-card-outline" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="new_supplier.dress" label="Dress Code" outlined dense
                                    hide-details="auto" prepend-inner-icon="mdi-tshirt-crew-outline" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="new_supplier.entrance" label="Entrance / Access" outlined dense
                                    hide-details="auto" prepend-inner-icon="mdi-door-open" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="new_supplier.age_limit" label="Age Limit" outlined dense
                                    hide-details="auto" prepend-inner-icon="mdi-account-alert-outline" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="new_supplier.server_time_limit" label="Service Time Limit"
                                    outlined dense hide-details="auto" prepend-inner-icon="mdi-timer-outline" />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="new_supplier.deposit_info" label="Deposit Info" outlined dense
                                    hide-details="auto" prepend-inner-icon="mdi-bank-outline" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-switch v-model="new_supplier.has_breakfast" label="Has Breakfast" color="primary"
                                    hide-details dense />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-switch v-model="new_supplier.has_bar" label="Has Bar" color="primary" hide-details
                                    dense />
                            </v-col>
                            <v-col cols="12">
                                <label class="field-label">Drinking Policy</label>
                                <wysiwyg v-model="new_supplier.drink_policy" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>

            <!-- ── 3. Notes ── -->
            <v-tab-item>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card class="section-card mb-4" elevation="0">
                            <div class="section-header">
                                <v-icon small class="mr-2" color="#525A68">mdi-tooltip-text-outline</v-icon>
                                General Notes
                            </div>
                            <v-card-text class="pt-4">
                                <v-text-field v-model="new_supplier.notes" label="Notes" outlined dense
                                    hide-details="auto" class="mb-4" />
                                <label class="field-label">Room Types</label>
                                <v-text-field v-model="new_supplier.room_types" label="Room Types" outlined dense
                                    hide-details="auto" class="mb-4" />
                                <label class="field-label">Other Offers</label>
                                <wysiwyg v-model="new_supplier.other_offers" class="mb-4" />
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card class="section-card mb-4" elevation="0">
                            <div class="section-header">
                                <v-icon small class="mr-2" color="#AA3939">mdi-shield-lock-outline</v-icon>
                                Internal / Admin
                            </div>
                            <v-card-text class="pt-4">
                                <label class="field-label">Admin Notes</label>
                                <wysiwyg v-model="new_supplier.admin_notes" class="mb-4" />
                                <label class="field-label">Special Notes</label>
                                <wysiwyg v-model="new_supplier.special_notes" />
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-tab-item>

        </v-tabs-items>

        <!-- Sticky Create Bar -->
        <div class="create-bar mt-6">
            <v-btn color="primary" rounded elevation="0" class="create-btn" :loading="creating"
                @click="createSupplier()">
                <v-icon left small>mdi-plus</v-icon>
                Create Supplier
            </v-btn>
        </div>

    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { lookups, loadLookups } from '@/common/companyLookups'
export default {
    components: {},
    props: [],
    data: () => ({
        tab: 0,
        creating: false,
        supplier_image_file: null,
        imagePreview: null,
        errors: {
            supplier_name: false,
            service_type_ids: false,
            email: false,
            supplier_locations: false,
        },
        new_supplier: {
            supplier_name: null,
            short_description: null,
            currency: null,
            pay_type: null,
            email: null,
            contact_name: null,
            contact_by: null,
            phone: null,
            mobile: null,
            free_phone: null,
            others: null,
            website: null,
            location_name: null,
            address: null,
            time_to_center: null,
            time_to_arrive: null,
            directions: null,
            dress: null,
            entrance: null,
            age_limit: 0,
            server_time_limit: null,
            deposit_info: null,
            has_breakfast: 0,
            has_bar: 0,
            drink_policy: null,
            notes: null,
            room_types: null,
            other_offers: null,
            description: null,
            admin_notes: null,
            special_notes: null,
        },
        supplier_locations: [],
        service_type_ids: [],
        sections: [
            { key: 'basic', label: 'Overview', icon: 'mdi-information-outline' },
            { key: 'policies', label: 'Policies', icon: 'mdi-file-document-outline' },
            { key: 'notes', label: 'Notes', icon: 'mdi-tooltip-text-outline' },
        ],
    }),
    mounted() {
        this.$store.dispatch('supplier/fetch_supplier_type')
        loadLookups('locations')
    },
    computed: {
        getLocation() {
            return lookups.locations
        },
        ...mapGetters({
            get_selected_company: 'auth/get_selected_company',
            get_supplier_type: 'supplier/get_supplier_type',
        })
    },
    methods: {
        showSnackBar(message) {
            this.$store.commit('auth/setMessage', { show: true, message: message }, { root: 1 })
        },
        previewImage() {
            if (this.supplier_image_file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.imagePreview = e.target.result
                }
                reader.readAsDataURL(this.supplier_image_file)
            } else {
                this.imagePreview = null
            }
        },
        validateForm() {
            let isValid = true

            // Reset errors
            this.errors = {
                supplier_name: false,
                service_type_ids: false,
                email: false,
                supplier_locations: false,
            }

            // Check required fields
            if (!this.new_supplier.supplier_name || this.new_supplier.supplier_name.trim() === '') {
                this.errors.supplier_name = true
                isValid = false
            }

            if (!this.service_type_ids || this.service_type_ids.length === 0) {
                this.errors.service_type_ids = true
                isValid = false
            }

            if (!this.new_supplier.email || this.new_supplier.email.trim() === '') {
                this.errors.email = true
                isValid = false
            }

            if (!this.supplier_locations || this.supplier_locations.length === 0) {
                this.errors.supplier_locations = true
                isValid = false
            }

            return isValid
        },
        async createSupplier() {
            // Validate form first
            if (!this.validateForm()) {
                this.$toast.error('Please fill in all required fields')
                return
            }

            this.creating = true

            const formData = new FormData()
            formData.append('company_id', this.get_selected_company.id)
            formData.append('supplier_locations', JSON.stringify(this.supplier_locations))
            formData.append('service_type_ids', JSON.stringify(this.service_type_ids))

            // Add supplier fields
            Object.keys(this.new_supplier).forEach(key => {
                if (this.new_supplier[key] !== null && this.new_supplier[key] !== undefined) {
                    formData.append(key, this.new_supplier[key])
                }
            })

            // Add image if selected
            if (this.supplier_image_file) {
                formData.append('supplier_image', this.supplier_image_file)
            }

            await this.$axios.post('admin/suppliers/create_supplier', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(({ data }) => {
                    this.showSnackBar(data.message)
                    if (data.response) {
                        this.$router.push({ name: '/supplier-setup', params: { supplier_id: data.data.id } })
                    }
                })
                .finally(() => {
                    this.creating = false
                })
        }
    },
}
</script>

<style scoped lang="scss">
.create-supplier-page {
    background-color: #F5F6FA;
    min-height: 100vh;
}

/* Header */
.create-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .create-title {
        font-size: 20px;
        font-weight: 700;
        color: #2C2C2C;
        margin: 0;
        line-height: 1.2;
    }

    .create-subtitle {
        font-size: 13px;
        display: block;
        margin-top: 2px;
    }
}

/* Tabs */
.create-tabs {
    border-bottom: 2px solid #EBEBEB;

    .tab-item {
        text-transform: none;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.2px;
        min-width: 110px;
    }
}

:deep(.v-tabs-slider-wrapper) {
    height: 2px !important;
}

.tabs-items {
    background: transparent !important;
}

/* Section Cards */
.section-card {
    border-radius: 12px !important;
    border: 1px solid #E8E8E8 !important;
    background-color: #fff;
    overflow: hidden;
}

.section-header {
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #7C7C7C;
    background-color: #FAFAFA;
    border-bottom: 1px solid #F0F0F0;
    padding: 10px 16px;
}

/* Field label */
.field-label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    color: #555;
    margin-bottom: 6px;
}

/* Image preview */
.image-preview {
    width: 100%;
    height: 160px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #F5F5F5;
    display: flex;
    align-items: center;
    justify-content: center;
}

.supplier-preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* Create bar */
.create-bar {
    display: flex;
    justify-content: flex-end;
}

.create-btn {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.3px;
    padding: 0 24px;
    height: 38px;
}
</style>